export const dataInfoografias = [
  // ===== GRUPO 1 =====
  {
    id: 1,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/1.jpg",
    alt: "Mecanismos de Participacion Ciudadana",
    grupo: 1,
  },
  {
    id: 2,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/2.jpg",
    alt: "Iniciativa Popular",
    grupo: 1,
  },
  {
    id: 3,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/3.jpg",
    alt: "Consulta Popular",
    grupo: 1,
  },
  {
    id: 4,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/4.jpg",
    alt: "Plebiscito",
    grupo: 1,
  },
  {
    id: 5,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/5.jpg",
    alt: "Referéndum",
    grupo: 1,
  },
  {
    id: 6,
    imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/infografias/6.jpg",
    alt: "Voz Ciudadana en el Cabildo",
    grupo: 1,
  },

  // ===== GRUPO 2 =====
  { id: 7, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/1.jpeg", alt: "Mecanismos de Participacion Ciudadana", grupo: 2 },
  { id: 8, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/2.jpeg", alt: "Iniciativa Popular", grupo: 2 },
  { id: 9, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/3.png", alt: "Consulta Popular", grupo: 2 },
  { id: 10, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/4.png", alt: "Plebiscito", grupo: 2 },
  { id: 11, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/5.jpg", alt: "Referéndum", grupo: 2 },
  { id: 12, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/6.jpg", alt: "Voz Ciudadana en el Cabildo", grupo: 2 },
  { id: 13, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/7.png", alt: "Voz Ciudadana en el Cabildo", grupo: 2 },
  { id: 14, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/8.png", alt: "Voz Ciudadana en el Cabildo", grupo: 2 },
  { id: 15, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/9.png", alt: "Voz Ciudadana en el Cabildo", grupo: 2 },
  { id: 16, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/10.png", alt: "Voz Ciudadana en el Cabildo", grupo: 2 },

  // ===== GRUPO 3 =====
  { id: 17, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/11.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 18, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/12.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 19, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/13.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 20, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/14.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 21, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/15.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 22, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/16.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 23, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/17.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 24, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/18.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 25, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/19.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 26, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/20.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 27, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/21.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },
  { id: 28, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/22.jpeg", alt: "Voz Ciudadana en el Cabildo", grupo: 3 },

  // ===== GRUPO 4 =====
  { id: 29, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/23.webp", alt: "Voz Ciudadana en el Cabildo", grupo: 4 },
  { id: 30, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/24.webp", alt: "Voz Ciudadana en el Cabildo", grupo: 4 },
  { id: 31, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/25.webp", alt: "Voz Ciudadana en el Cabildo", grupo: 4 },

  // ===== GRUPO 5 =====
  { id: 32, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/29.webp", alt: "3", grupo: 5 },
  { id: 33, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/30.webp", alt: "3", grupo: 5 },

  // ===== GRUPO 6 =====
  { id: 34, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/26.webp", alt: "1", grupo: 6 },
  { id: 35, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/27.webp", alt: "2", grupo: 6 },
  { id: 36, imgURL: "https://participacion-ciudadana.itetlax.org.mx/assets/img/InfografiasTemp/28.webp", alt: "3", grupo: 6 },
];
